const ACCOUNT_USER_TYPE_GROUP_EXTERNAL: string = 'external';

export default ACCOUNT_USER_TYPE_GROUP_EXTERNAL;
